import Cookies from "js-cookie"
import { COOKIES } from "../../enum"

const gaDomain = process.env.GATSBY_GA_DOMAIN

export const checkCookies = () => {
  const cookieState = Cookies.get(COOKIES.PERFORMANCE_COOKIES)
  const allCookies = Cookies.get()
  const gaCookies = ["_ga", "_ga_HG6ES94S5Q", "_gid", "_gat_gtag_UA_56517066_2"]

  if (cookieState !== "true") {
    Object.entries(allCookies).forEach(([keys]) => {
      if (gaCookies.includes(keys)) {
        Cookies.remove(keys, {
          path: "/",
          domain: gaDomain,
        })
      }
    })
  }
}

export const getUserToken = () => Cookies.get(COOKIES.USER_TOKEN)

export const deleteUserToken = () =>
  Cookies.remove(COOKIES.USER_TOKEN, { path: "/", domain: gaDomain })
